import { useState } from "react";
import { PortableText } from "@portabletext/react";
import { useTranslation } from "react-i18next";

function FaqSection({ value }) {
  const { t } = useTranslation(["blog"]);
  const faqData = value?.faqData;
  const heading = faqData?.heading || t("faqHeading", "Často kladené otázky");
  const faqItems = faqData?.faqItems || [];
  const [openIndex, setOpenIndex] = useState(null);

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  if (!faqItems.length) {
    return (
      <div className='text-center text-gray-500'>
        {t("faqEmpty", "Žiadne FAQ položky k dispozícii")}
      </div>
    );
  }

  return (
    <div className='flex justify-center w-full my-8'>
      <div className='w-full max-w-[800px] p-6 bg-white rounded-lg shadow-xs'>
        <h2 className='text-2xl font-semibold mb-6 text-inaqgold'>
          {heading}
        </h2>
        <div className='space-y-4'>
          {faqItems.map((item, index) => (
            <div
              key={index}
              className='border-bottom border-gray-200 rounded-xs overflow-hidden'
            >
              <button
                className={`w-full p-r4 py-2 text-left font-rubik text-[14px] font-bold flex justify-between items-center transition-colors ${
                  openIndex === index
                    ? "bg-white text-inaqgold"
                    : "bg-white text-gray-900 hover:bg-gray-50"
                }`}
                onClick={() => toggleAccordion(index)}
              >
                <span>{item.question}</span>
                <svg
                  className={`w-4 h-4 transition-transform ${
                    openIndex === index ? "rotate-180" : ""
                  }`}
                  fill='none'
                  stroke='currentColor'
                  viewBox='0 0 24 24'
                  xmlns='http://www.w3.org/2000/svg'
                >
                  <path
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    strokeWidth='2'
                    d='M19 9l-7 7-7-7'
                  />
                </svg>
              </button>
              {openIndex === index && (
                <div className='px-1 md:px-4 py-3 font-rubik text-[14px] border-t border-gray-200 text-gray-500 faq-answer-text'>
                  <PortableText value={item.answer} />
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default FaqSection;
